/** @module CostScenario/CostScenarioForm */
define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/form/Widget",
	"csi/sessionConstants",
	"csi/xml"
], function(declare,_,csi,comm,PostRequest,Widget,sessionConstants,xml) {

	var ROUTING = "QuoteRouting";
	var BOM = "QuoteBOM";

	return declare(Widget, {

		 /**
		 * Remove Material Security Group from Material Create form for SMB instance
		 * @override
		 */
		_resolveView: function() {
			if(sessionConstants.hasCloudGoodLicense){
				this.defView.removeField(ROUTING);
			}
			_.each(this.defView.m_fields, function(field){
				field.bForceEditable = true;
			});
			this.inherited(arguments);
		},

		 /**
		 * Add default values for Routing and BOM fields
		 * @override
		 */
		_buildView: function() {
			var view = this.cacheView.getNode(this.getFormNode().__Parent__);

			if (view) {
				var quoteRev = view;
				if (view.$Type == "SupplierItem") {
					quoteRev = this.cacheView.getNode(view.LatestRevision);
				}
				if (quoteRev.QuoteBOM && quoteRev.QuoteBOM != csi.EMPTY_URL) {
					this.addDefaultValue(BOM, quoteRev.QuoteBOM);
				}
				if (quoteRev.QuoteRouting && quoteRev.QuoteRouting != csi.EMPTY_URL) {
					this.addDefaultValue(ROUTING, quoteRev.QuoteRouting);
				}
			}

			this.inherited(arguments);
		},

        /**
         * C8-8687 : add dependency path for the Routing field on the CreateCostScenario form (see QuoteRoutingRenderer.js)
         *
         * @param {Node} - node
         * @return {Request}
         */
        _getRootRequest: function(node) {
            var supplierItemRev = this.getViewNode() || this.defView.getSource().getParent();
            var req = this.inherited(arguments) || new PostRequest(comm.MOD_SEARCH, comm.OP_URL);
            req.addParameter(comm.QUERY_URL, [supplierItemRev.$URL], true);
            req.addDependencyPaths(["Child:__Parent__/Child:__Parent__/Child:__Parent__"]);

            return req;
        }

	});
});